<template>
  <md-card class="md-card-signup wcard">
    <slot name="title"></slot>

    <md-card-content>
      <div class="md-layout">
        <slot name="content-header"></slot>
        <slot name="content-left"></slot>
        <slot name="content-right"></slot>
        <slot name="content-footer"></slot>
      </div>
    </md-card-content>

    <md-card-actions>
      <slot name="footer"></slot>
    </md-card-actions>
  </md-card>
</template>

<script>
export default {
  name: "signup-card",
};
</script>

<style lang="css">
</style>
